// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"61a1b5b2","63":"29c7f09b","226":"1681f7e6","239":"1630385a","732":"9c51eb28","977":"5f8fc278"}[chunkId] + ".chunk.js";
};